import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import ResourceRepository from '../../api/repositories/ResourceRepository';
import {useUserPreferenceStore} from '../../stores/userPreferenceStore';

export async function handleQrCode(to: RouteLocationNormalized): Promise<NavigationGuardReturn> {
    const resourceId = to.params.resourceId;

    if (!resourceId) {
        return {name: 'Home'};
    }

    try {
        const resourceCheck = await ResourceRepository().check(resourceId);
        const newBooking = await useUserPreferenceStore().newBookingPreferenceReady();

        if (newBooking) {
            return {
                name: 'BookingMap',
                params: {roomId: resourceCheck.resource.room},
                query: {resourceId: resourceCheck.resource.id},
            };
        }

        switch (resourceCheck?.resourceType) {
            case 'seat':
                return {name: 'DayBookingConfirmationSeat', params: {seatId: resourceId}};
            case 'zone':
                return {name: 'DayBookingConfirmationZone', params: {zoneId: resourceId}};
            case 'meeting-room':
                return {
                    name: 'DayBookingConfirmationMeetingRoom',
                    params: {meetingRoomId: resourceId},
                };
            default:
                return {name: 'Home'};
        }
    } catch {
        return {name: 'Home'};
    }
}
